import type { HelpFile } from '../../types/help'
import { ExecutionDetailTestIds } from '../../../testids/ExecutionDetailTestIds'

export const executionDetailHelp: HelpFile = {
  docPage: '/docs/jobs/job-scheduler',
  texts: {
    [ExecutionDetailTestIds.executionDetailTitle]:
      'Details for a single job execution — status, timing, task tree, and error information.',
    [ExecutionDetailTestIds.cardExecutionInfo]:
      'Execution summary — status, start and end time, duration, and the user or schedule that triggered it.',
    [ExecutionDetailTestIds.btnCancelExecution]:
      'Request cancellation of this running execution — the job stops at the next safe checkpoint.',
    [ExecutionDetailTestIds.cardTitleExecutionError]:
      'Error message and stack trace recorded when this execution failed.',
    [ExecutionDetailTestIds.linkJobDetail]:
      'Open the parent job to inspect its definition and other executions.',
    [ExecutionDetailTestIds.sectionExecutionStatistics]:
      'Counters reported by the job — items processed, succeeded, and failed.',
    [ExecutionDetailTestIds.sectionTaskExecutions]:
      'Individual tasks this job spawned, with status and duration for each.',
    [ExecutionDetailTestIds.badgeSseConnection]:
      'Live-update connection state for this execution — connecting, connected, or disconnected.',
    [ExecutionDetailTestIds.executionErrorMessage]:
      'The error message reported when the execution failed — used to diagnose the underlying problem.',
  },
}
